const ts = {
    YOUR_EMAIL_TEXT:{
        description: 'Your Email',
        primaryValue: 'Your Email',
        stringKey: 'YOUR_EMAIL_TEXT',
    },
    MANAGERAAPROVAL_SWOOSHONLY_MODAL_TEXT:{
        description: 'Please note: Manager approval is only required for Swoosh.com access',
        primaryValue: 'Please note: Manager approval is only required for Swoosh.com access',
        stringKey: 'MANAGERAAPROVAL_SWOOSHONLY_MODAL_TEXT',
    },
    REQUESTEDACCESS_TEXT:{
        description: 'Requested Access',
        primaryValue: 'Requested Access',
        stringKey: 'REQUESTEDACCESS_TEXT',
    },
    SELECT_APPLY_TEXT:{
        description: 'Select and Apply',
        primaryValue: '(Select all that apply)',
        stringKey: 'SELECT_APPLY_TEXT',
    },
    YOUR_SWOOSH_Mobile_TEXT:{
        description: '+8600000000000',
        primaryValue: '+8600000000000',
        stringKey:'YOUR_SWOOSH_Mobile_TEXT'
    },
    YOUR_SWOOSH_EMAIL_TEXT:{
        description: 'Your Swoosh Email',
        primaryValue: 'Your Swoosh Email',
        stringKey: 'YOUR_SWOOSH_EMAIL_TEXT'
    },
    ACCOUNT_LINKED:{
        description: 'Account Linked',
        primaryValue: 'Account Linked',
        stringKey: 'ACCOUNT_LINKED'
    },
    LINKACCOUNT_TEXT_P1:{
        description: 'I hereby consent to',
        primaryValue: 'I hereby consent to',
        stringKey: 'LINKACCOUNT_TEXT_P1'
    },
    LINKACCOUNT_TEXT_Link:{
        description: 'Swoosh Terms and Conditions',
        primaryValue: 'Swoosh Terms and Conditions',
        stringKey: 'LINKACCOUNT_TEXT_Link'
    },
    LINKACCOUNT_TEXT_P2:{
        description: 'and consent to linking my Nike member account to access Swoosh.',
        primaryValue: 'and consent to linking my Nike member account to access Swoosh.',
        stringKey: 'LINKACCOUNT_TEXT_P2'
    },
    BTN_LinkAccount:{
        description: 'Link Account',
        primaryValue: 'Link Account',
        stringKey: 'BTN_LinkAccount'
    },
    BTN_UPDATE:{
        description: 'Update',
        primaryValue: 'Update',
        stringKey: 'BTN_UPDATE'
    }
}

export default ts;